// filepath: /C:/Users/nitis/Desktop/uii/client/src/components/nav Components/Profile.js
import { useState, useEffect, useMemo, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import SwitchButton from '../shared/switchButton'; // Import the SwitchButton component
import styles from './profile.module.css'; // Use CSS modules
import { WithContext as ReactTags } from 'react-tag-input';
import defaultProfile1 from '../images/default-profile1.jpg';
import Notification from '../shared/Notification';

const Profile = () => {
    const [profile, setProfile] = useState({
        name: '',
        emailOrPhone: '',
        // skills: '',
        gender: '',
        socialPoints: 0,
        education: '',
        about: '',
        profilePicture: '',
        resume: '',
        defaultMessage: '',
        // autoApply:'',
        allMessage: '',
        addGroup:'',
        offerRemoveTime: '',
        location: '',
        timeAvailability: '',
        myType: ''
    });
    const [isEditing, setIsEditing] = useState(false);
    const [notification, setNotification] = useState('');
    const [uploading, setUploading] = useState(false);
    const [resumeName, setResumeName] = useState('');
    // const [autoApply1, setAutoApply1] = useState(false); // Initialize autoApply state
    const [allMessageButton, setAllMessageButton] = useState(true); // Initialize addGroup state
    const [addGroupButton, setAddGroupButton] = useState(true); // Initialize autoApply state
    const [offerRemoveTimeDropdown, setOfferRemoveTimeDropdown] = useState(['2 Hours', '6 Hours', '1 Day', '3 Days', '7 Days', '21 Days']);
    const [offerRemoveTime, setOfferRemoveTime] = useState('');
    const navigate = useNavigate();
    const token = useMemo(() => localStorage.getItem('token'), []);

    const [showTooltip, setShowTooltip] = useState(false);
    const [tags, setTags] = useState([]);
    const [skillSuggestions, setSkillSuggestions] = useState([]); // For dropdown suggestions
    const [searchQuery, setSearchQuery] = useState(''); // For skill search input

     const KeyCodes = {
        comma: 188,
        enter: 13,
      };
      
    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const [showLocationModal, setShowLocationModal] = useState(false);
    const [citySearch, setCitySearch] = useState('');
    const [cityResults, setCityResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [timeAvailabilityDropdown, setTimeAvailabilityDropdown] = useState(['All Times', 'Weekdays Mornings', 'Weekdays Afternoons', 'Weekdays Evenings', 'Weekends Mornings', 'Weekends Afternoons', 'Weekends Evenings', 'Flexible']);

    const [myTypeDropdown, setMyTypeDropdown] = useState(['INTJ', 'INTP', 'ENTJ', 'ENTP', 
        'INFJ', 'INFP', 'ENFJ', 'ENFP', 'ISTJ', 'ISFJ', 'ESTJ', 'ESFJ', 'ISTP', 'ISFP', 
        'ESTP', 'ESFP', 'soft', 'bold', 'introvert',  'quickLearner', 'slowLearner', 
        'lazyLearner', 'activeLearner', 'queryDiminisher', 'queryAcknowledger', 
        'soulCrusher', 'soulExpander', 'respecting', 'crushing', 'dreamSupporter', 
        'dreamDenier', 'deepSpiritual', 'atheist', 'bhakt']);


    const handleAddition = (tag) => {
        if (!tag || !tag.text) return;
        const normalizedText = tag.text.trim().toLowerCase().replace(/[^a-zA-Z0-9 ]/g, '');
        if (!tags.find(t => t.text === normalizedText)) {
          setTags([...tags, { id: normalizedText, text: normalizedText }]);
        }
          setSearchQuery('');          // clear input after enter/comma
      };
      
    // const handleDelete = (i) => {
    //     setTags(tags.filter((tag, index) => index !== i));
    //   };
    const handleDelete = (index) => {
    setTags(prev => prev.filter((_, i) => i !== index));
    };
      const handleSkillInputChange = (input) => {
        setSearchQuery(input);
    };

    const handleSkillSelect = (skill) => {
        if (!tags.find(tag => tag.text === skill.name)) {
            setTags([...tags, { id: skill._id, text: skill.name }]);
        }
        setSearchQuery(''); // Clear the input
        setSkillSuggestions([]); // Clear suggestions
    };

    // Fetch skill suggestions from the backend
    useEffect(() => {
        const fetchSkills = async () => {
            if (searchQuery.trim() === '') {
                setSkillSuggestions([]);
                return;
            }

            try {
                const response = await axios.get(`/api/profile/search-skills?query=${searchQuery}`);
                setSkillSuggestions(response.data);
            } catch (error) {
                console.error('Error fetching skill suggestions:', error.message);
            }
        };

        fetchSkills();
    }, [searchQuery]);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'Please login first');
                    navigate('/login');
                    return;
                }
                const response = await axios.get('/api/profile/get-profile', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setProfile(response.data.applicant); 
                //    console.log('Fetched profile data:', response.data.skillNames);
                const formattedTags = response.data.skillNames.map(skill => ({
                    id: skill,
                    text: skill
                    }));
                setTags(formattedTags);                
                // setAutoApply1(response.data.autoApply); // Set the initial value of autoApply from the profile data
                setAllMessageButton(response.data.applicant.allMessage);
                setAddGroupButton(response.data.applicant.addGroup);
                setOfferRemoveTime(response.data.applicant.offerRemoveTime || '21 Days');
                setResumeName(response.data.applicant.resume.split('/').pop());

            } catch (error) {
                console.error('Error fetching profile:', error.message);
                // localStorage.removeItem('token'); // Optionally remove invalid token
                localStorage.setItem('notification', 'Session expired, please login again');
            }
        };

        fetchProfile();
    }, [navigate]);
    // console.log("tags", tags);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (isEditing) {
                event.preventDefault();
                event.returnValue = 'You have unsaved changes. Do you want to leave?';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isEditing]);

    const handleSaveClick = async () => {
        if (uploading) {
            setNotification('Please wait for the upload to complete');
            return;
        }
        // Extract skill names from tags
        const skillNames = tags.map(tag => tag.text);
        
        // Include skills in the profile data being sent
        const updatedProfile = {
            ...profile,
            skills: skillNames 
        };

        try {
            await axios.put('/api/profile/update-profile', updatedProfile, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            setNotification('Profile updated successfully');
            setIsEditing(false);
        } catch (error) {
            setNotification('Error updating profile');
            console.error('Error updating profile:', error.message);
        }
    };

    const handleCancelClick = () => {
        setIsEditing(false);
    };


    // const handleAutoApplyChange = async (value) => {
    //     setAutoApply1(value); // Update the local state

    //     try {
    //         // Send the updated value to the backend
    //         await axios.put(
    //             '/api/profile/update-auto-apply',
    //             { autoApply: value },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 },
    //             }
    //         );
    //         setNotification('Auto Apply setting updated successfully');
    //     } catch (error) {
    //         console.error('Error updating Auto Apply setting:', error);
    //         setNotification('Error updating Auto Apply setting');
    //     }
    // };
    // }, [isEditing]);

    const handleCurrentLocation = async () => {
        try {
            if (!navigator.geolocation) {
                setNotification('Geolocation is not supported by your browser');
                return;
            }
            
            setNotification('Getting your location...');
            
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    
                    try {
                        // Step 1: Get address from coordinates via backend
                        const geocodeResponse = await axios.post(
                            '/api/profile/geocode-location',
                            { latitude, longitude },
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            }
                        );
                        
                        const address = geocodeResponse.data.address;
                        // console.log('Got address:', address);
                        
                        // Step 2: Save to database
                        await axios.put(
                            '/api/profile/update-location',
                            { location: address },
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            }
                        );
                        
                        // Step 3: Update local state
                        setProfile({ ...profile, location: address });
                        setNotification('Location added to profile');
                        setShowLocationModal(false);
                    } catch (error) {
                        // console.error('Error saving location:', error.response?.data?.message || error.message);
                        setNotification(error.response?.data?.message || 'Error saving location to profile');
                    }
                },
                (error) => {
                     // Handle geolocation errors with specific messages
                        let errorMessage = 'Unable to retrieve your location';
                        
                        switch(error.code) {
                            case error.PERMISSION_DENIED:
                                errorMessage = 'Location permission denied. Please enable location access in your browser settings.';
                                break;
                            case error.POSITION_UNAVAILABLE:
                                errorMessage = 'Location information is unavailable.';
                                break;
                            case error.TIMEOUT:
                                errorMessage = 'Location request timed out.';
                                break;
                            default:
                                errorMessage = 'An unknown error occurred while getting location.';
                        }
                        
                        // console.error('Geolocation error:', errorMessage);
                        setNotification(errorMessage);
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 10000, // 10 seconds
                        maximumAge: 0
                    }
                );
        } catch (error) {
            // console.error('Error adding location:', error.message);
            setNotification('Error adding location to profile');
        }
    };

    const handleSelectCity = async (city) => {
        const locationName = city.display_name;
        
        try {
            await axios.put(
                '/api/profile/update-location',
                { location: locationName },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            
            setProfile({ ...profile, location: locationName });
            setNotification('Location updated successfully');
            setShowLocationModal(false);
            setCitySearch('');
            setCityResults([]);
        } catch (error) {
            console.error('Error updating location:', error);
            setNotification('Error updating location');
        }
    };

    const debounce = (func, wait) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
        };
    };

    
    // Update city search to use backend
    const debouncedCitySearch = useCallback(
        debounce(async (searchTerm) => {
            if (searchTerm.length < 2) {
                setCityResults([]);
                return;
            }
            
            setIsSearching(true);
            
            try {
                const response = await axios.get('/api/profile/search-cities', {
                    params: { query: searchTerm },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                
                // console.log('City search results:', response.data.results);
                setCityResults(response.data.results);
            } catch (error) {
                // console.error('Error searching cities:', error.response?.data?.message || error.message);
                setNotification('Error searching for cities');
            } finally {
                setIsSearching(false);
            }
        }, 500),
        [token]
    );

    const handleCitySearch = (searchTerm) => {
        setCitySearch(searchTerm);
        debouncedCitySearch(searchTerm);
    };

    const handleRemoveLocation = async () => {
        try {
            await axios.delete('/api/profile/remove-location',
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            
            setProfile({ ...profile, location: '' });
            setNotification('Location removed successfully');
            setShowLocationModal(false);
        } catch (error) {
            // console.error('Error removing location:', error.message);
            setNotification('Error removing location');
        } 
        // finally {
        //     setIsUpdatingLocation(false);
        // }
    };
    const handleAllMessage = async (value) => {
        setAllMessageButton(value);

        try {
            await axios.put(
                '/api/profile/update-all-message',
                { allMessage: value },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setNotification('Anyone Message setting updated successfully');
        } catch (error) {
            // console.error('Error updating Anyone Message setting:', error);
            setNotification('Error updating Anyone Message setting');
        }
    };
    const handleAddGroup = async (value) => {
        setAddGroupButton(value); // Update the local state

        try {
            // Send the updated value to the backend
            await axios.put(
                '/api/profile/update-add-group',
                { addGroup: value },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setNotification('Group Add setting updated successfully');
        } catch (error) {
            // console.error('Error updating Group Add setting:', error);
            setNotification('Error updating Group Add setting');
        }
    };

    const handleOfferRemoveTimeChange = async (e) => {
    setProfile({ ...profile, offerRemoveTime: e.target.value });
        try {
            await axios.put(
                '/api/profile/update-offer-remove-time',
                { offerRemoveTime: e.target.value },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setNotification('Offer Remove Time updated successfully');
        } catch (error) {
            // console.error('Error updating Offer Remove Time:', error);
            setNotification('Error updating Offer Remove Time');
        }
    };
    
    const handleTimeAvailabilityChange = async (e) => {
    setProfile({ ...profile, timeAvailability: e.target.value });
        try {
            await axios.put(
                '/api/profile/update-time-availability',
                { timeAvailability: e.target.value },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setNotification('Time Availability updated successfully');
        } catch (error) {
            // console.error('Error updating Time Availability:', error);
            setNotification('Error updating Time Availability');
        }
    };

    const handlePersonalityTypeChange = async (e) => {
    setProfile({ ...profile, personalityType: e.target.value });
        try {
            await axios.put(
                '/api/profile/update-personality-type',
                { personalityType: e.target.value },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setNotification('Personality Type updated successfully');
        }
        catch (error) {
            // console.error('Error updating Personality Type:', error);
            setNotification('Error updating Personality Type');
        }
    };
    

    const handleChange = (e) => {
        setProfile({ ...profile, [e.target.name]: e.target.value });
    };
    const toggleTooltip = () => {
        setShowTooltip(prev => !prev);
      };

    const handleEditClick = () => {
        setIsEditing(true);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleUpload = async (e, type) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'ml_default'); 

        setUploading(true);

        try {
            const response = await axios.post('/api/upload/upload-all', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            const url = response.data.url;

            setProfile({ ...profile, [type]: url });
            if (type === 'resume') {
                setResumeName(file.name);
            }

            setUploading(false);
        } catch (error) {
            // console.error('Error uploading file:', error);
            setUploading(false);
        }
    };

    return (
        <div>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}       
            <div className={styles.profileContainer}>
                <h2>Profile</h2>
                         
                <div className={styles.profileInfo}>
                    <label>Name:</label>
                    {isEditing ? (
                        <input
                            type="text"
                            name="name"
                            value={profile.name}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{profile.name}</p>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>Email or Phone:</label>
                    {isEditing ? (
                        <input
                            type="text"
                            name="emailOrPhone"
                            value={profile.emailOrPhone}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{profile.emailOrPhone}</p>
                    )}
                </div>
                {/* <div className={styles.profileInfo}>
                    <label>Skills:</label>
                    {isEditing ? (
                        <input
                            type="text"
                            name="skills"
                            value={profile.skills}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{profile.skills}</p>
                    )}
                </div> */}
                <div className={styles.profileInfo}>
                    <label>Skills:</label>
                    {isEditing ? (
                        <div className={styles.requirements}>
                            <div className={styles.reactTagsContainer}>
                                <ReactTags classNames={{
                                                root: styles.reactTags,
                                                tagInput: styles.tagInput, 
                                                tag: styles.tag,
                                                remove: styles.remove
                                            }}
                                    tags={tags}
                                    handleDelete={handleDelete}
                                    handleAddition={handleAddition}
                                    delimiters={delimiters}
                                    handleInputChange={handleSkillInputChange}  
                                    // inputValue={searchQuery}
                                    placeholder=""
                                    autofocus={false}
                                />
                                {skillSuggestions.length > 0 && (
                                    <ul className={styles.skillDropdown}>
                                        {skillSuggestions.map(skill => (
                                            <li
                                                key={skill._id}
                                                onClick={() => handleSkillSelect(skill)}
                                                className={styles.skillDropdownItem}
                                            >
                                                {skill.name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div> 
                    ) : (
                        <p>{Array.isArray(tags) ? tags.map(tag => tag.text).join(', ') : ''}</p>  
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>Gender:</label>
                    {isEditing ? (
                        <input
                            type="text"
                            name="gender"
                            value={profile.gender}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{profile.gender}</p>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>Social Points:</label>
                    {isEditing ? (
                        <input
                            type="number"
                            name="socialPoints"
                            value={profile.socialPoints}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{profile.socialPoints}</p>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>Education:</label>
                    {isEditing ? (
                        <input
                            type="text"
                            name="education"
                            value={profile.education}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{profile.education}</p>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>About:</label>
                    {isEditing ? (
                        <textarea
                            name="about"
                            value={profile.about}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{profile.about}</p>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>Profile Picture:</label>
                    {isEditing ? (
                        <>
                            <input
                                type="text"
                                name="profilePicture"
                                value={profile.profilePicture}
                                onChange={handleChange}
                            />
                            <input
                                type="file"
                                onChange={(e) => handleUpload(e, 'profilePicture')}
                            />
                        </>
                    ) : (
                        <div>
                            {profile.profilePicture ? (
                                <img
                                    title={profile.name}
                                    src={profile.profilePicture ? profile.profilePicture.replace('/upload/', '/upload/w_384,h_400,c_fill/') : defaultProfile1}
                                    alt="Profile"
                                    className={styles.profilePicture}
                                    onError={(e) => { e.target.src = '/default-avatar.png'; }}
                                    onClick={() => window.open(profile.profilePicture, '_blank')}
                                    style={{ cursor: 'pointer' }}
                                />
                            ) : (
                                <p>No profile picture</p>
                            )}
                        </div>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>My Location:</label>
                    {isEditing ? (
                        <>
                            <input
                                type="text"
                                name="location"
                                value={profile.location}
                                onChange={handleChange}
                            />
                            {profile.location ? (
                            <button onClick={() => setShowLocationModal(true)} className={styles.changeLocationBtn}>Change</button>
                            ) : (
                                <button onClick={() => setShowLocationModal(true)} className={styles.changeLocationBtn}>Add</button>
                            )}
                        </>
                    ) : (
                        <>
                        <p>{profile.location}</p>
                        {profile.location ? (
                        <button onClick={() => setShowLocationModal(true)} className={styles.changeLocationBtn}>Change</button>
                        ) : (
                            <button onClick={() => setShowLocationModal(true)} className={styles.changeLocationBtn}>Add</button>
                        )}
                    </>
                    )}
                </div>

                <div className={styles.profileInfo}>
                    <label>Resume:</label>
                    {isEditing ? (
                        <>
                            <input
                                type="text"
                                name="resume"
                                value={profile.resume}
                                onChange={handleChange}
                            />
                            <input
                                type="file"
                                onChange={(e) => handleUpload(e, 'resume')}
                            />
                        </>
                    ) : (
                        <a href={profile.resume} target="_blank" rel="noopener noreferrer">{resumeName}</a>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>Default Message:</label>
                    {isEditing ? (
                        <input
                            type="text"
                            name="defaultMessage"
                            value={profile.defaultMessage}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{profile.defaultMessage}</p>
                    )}
                    <div className={styles.infoButtonContainer}>
                        {!isEditing&&(
                            <div className={styles.infoCircle} onClick={toggleTooltip}>i</div>)}
                            {showTooltip && (
                                <div className={styles.infoTooltip}>
                                    <p>Set Default Messages in profile to Send Message to Recruiters automatically.</p>
                                    <p>You can login with email or phone.</p>
                                    <p>Password must be at least 6 characters.</p>
                                    <p>Send and receive all messages are turuned ON simultaneously.</p>
                                </div>)}
                        </div>
                    </div>
                <div>
                {/* <SwitchButton
                    isChecked={autoApply1}
                    onChange={handleAutoApplyChange}
                    label="Auto Apply"
                    value={autoApply1} // Pass the value prop to the SwitchButton
                /> */}
                </div>
                <div className={styles.profileInfo}>
                    <label>Receive Messages from All</label>
                    <SwitchButton
                        isChecked={allMessageButton}
                        onChange={handleAllMessage}
                        value={allMessageButton}
                    />
                </div>
                <div className={styles.profileInfo}>
                    <label>Friends Add You to Group</label>
                    <SwitchButton
                        isChecked={addGroupButton}
                        onChange={handleAddGroup}
                        value={addGroupButton}
                    />
                </div>
                <div className={styles.profileInfo}>
                    <label>Sent Offer Auto Remove Time</label>
                    <div className={styles.dropdown}>
                        <select
                            name="offerRemoveTime"
                            value={profile.offerRemoveTime}
                            onChange={handleOfferRemoveTimeChange}
                        >
                            {offerRemoveTimeDropdown.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className={styles.profileInfo}>
                    <label>Time Availability</label>
                    <div className={styles.dropdown}>
                        <select
                            name="timeAvailability"
                            value={profile.timeAvailability}
                            onChange={handleTimeAvailabilityChange}
                        >
                            {timeAvailabilityDropdown.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className={styles.profileInfo}>
                    <label>My Type:</label>
                    <div className={styles.dropdown}>
                        <select
                            name="personalityType"
                            value={profile.personalityType}
                            onChange={handlePersonalityTypeChange}
                        >
                            {myTypeDropdown.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                {isEditing ? (
                    <div className={styles.profileActions}>
                        <button onClick={handleSaveClick} disabled={uploading}>Save</button>
                        <button onClick={handleCancelClick}>Cancel</button>
                    </div>
                ) : (
                    <button onClick={handleEditClick}>Edit</button>
                )}
            </div>
            {showLocationModal && (
                <div className={styles.modalOverlay} onClick={() => setShowLocationModal(false)}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <h3>Add Location</h3>
                        {profile.location && (<><p>{profile.location}</p><p className={styles.removeLocationBtn} onClick={() => handleRemoveLocation()} title="Remove Location">X</p></>)}
                        <button 
                            className={styles.currentLocationBtn}
                            onClick={handleCurrentLocation}
                        >
                            📍 Use Current Location
                        </button>
                        
                        <div className={styles.divider}>OR</div>
                        
                        {/* City Search */}
                        <div className={styles.citySearch}>
                            <input
                                type="text"
                                placeholder="Search for a city..."
                                value={citySearch}
                                onChange={(e) => handleCitySearch(e.target.value)}
                                className={styles.searchInput}
                            />
                            
                            {isSearching && <p>Searching...</p>}
                            
                            {cityResults.length > 0 && (
                                <div className={styles.searchResults}>
                                    {cityResults.map((city, index) => (
                                        <div
                                            key={index}
                                            className={styles.cityResult}
                                            onClick={() => handleSelectCity(city)}
                                        >
                                            <strong>{city.name || city.display_name.split(',')[0]}</strong>
                                            <br />
                                            <small>{city.display_name}</small>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        
                        <button 
                            className={styles.closeBtn}
                            onClick={() => {
                                setShowLocationModal(false);
                                setCitySearch('');
                                setCityResults([]);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Profile;


// pls apply a info icon tha on click or hover will show turns off automatically
// after 40 days, pls turn on after recent turn on and date showing turned off
// in 40 days (reverse counting) and in db one column of last turned on if is turned on.